import React from 'react';

export default props => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
            <rect x="1.5" y="3.5" width="13" height="9" rx="1" strokeWidth="1"/>
            <path d="M2 4l6 4.5L14 4" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
};